import { render, staticRenderFns } from "./CreateProjectLinkModal.vue?vue&type=template&id=67af2f36&"
import script from "./CreateProjectLinkModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports